import { emberApi } from './api';
import { cachedHome, loadHome } from './home-page-cache';
import { parseRoute } from './router';

function pathnameOf(to: string): string | null {
  if (typeof window === 'undefined') return to.split(/[?#]/)[0] || '/';
  try {
    const url = new URL(to, window.location.origin);
    return url.origin === window.location.origin ? url.pathname : null;
  } catch {
    return null;
  }
}

/** Warm the data owned by a route when a visitor signals navigation intent. */
export function prefetchRouteData(to: string): void {
  const pathname = pathnameOf(to);
  if (!pathname || parseRoute(pathname).name !== 'landing' || cachedHome()) return;
  void loadHome(() => emberApi.home()).catch(() => {
    // Intent prefetch is opportunistic. The page owns visible failure handling.
  });
}
